module.exports = __webpack_public_path__ + "assets/img/icon-result-success.3df8be56.png";